import { ReactNode, createContext, useState } from 'react'

type ValidationContextValue = {
	country?: string
	setCountry: (value?: string) => void
}

type ValidationContextProviderProps = {
	children: ReactNode
}

export const ValidationContext = createContext<ValidationContextValue | undefined>(undefined)

export const ValidationContextProvider = ({ children }: ValidationContextProviderProps) => {
	const [country, setCountry] = useState<string>()

	return (
		<ValidationContext.Provider value={{ country, setCountry }}>
			{children}
		</ValidationContext.Provider>
	)
}
